"use strict";

exports.__esModule = true;

var _stack = _interopRequireDefault(require("./stack"));

exports.Stack = _stack["default"];

var _dodge = _interopRequireDefault(require("./dodge"));

exports.Dodge = _dodge["default"];

var _symmetric = _interopRequireDefault(require("./symmetric"));

exports.Symmetric = _symmetric["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@antv/f2/lib/geom/adjust/index.js
// module id = 393
// module chunks = 3